import { useEffect } from "react";
import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
} from "react-icons/fa";

import { BsTwitterX } from "react-icons/bs";

import {
    FaChevronRight,
} from "react-icons/fa";
import logo from '../assets/cloud-call-logo.png';

import "./Footer.css";

export default function Footer() {
    useEffect(() => {
        const scriptId = "cloudcall-widget-script";
        let script = document.getElementById(scriptId);

        if (!script) {
            script = document.createElement("script");
            script.id = scriptId;
            script.src = "https://cloudcall.voicebridg.com/widget.js";
            script.async = true;
            script.defer = true;
            script.setAttribute("data-key", "3");
            document.body.appendChild(script);
        }
    }, []);

    return (
        <>
            <footer className="footer">

                <div className="container footer-grid">

                    {/* Logo */}

                    <div className="footer-col">
                        <div className="logo">
                            <img src={logo} alt="cloud-call-logo" />
                        </div>

                        <p>
                            Cloud Call intelligent voice agent
                            solutions transform everyday
                            customer interactions into
                            human-like, meaningful
                            experiences.
                        </p>

                    </div>

                    {/* Contact */}

                    <div className="footer-col">

                        <h3>CONTACT</h3>

                        <ul>

                            <li>Gaborone CBD</li>

                            <li>Plot 54368, iTowers Unit 4A</li>

                            <li>+267 3165466</li>

                            <li>info@stenciltechnologies.com</li>

                            

                        </ul>

                    </div>

                    {/* Useful */}

                    <div className="footer-col">

                        <h3>USEFUL LINKS</h3>

                        <ul>

                        

                            <li><FaChevronRight /> Intelligent AI Voice Agent</li>

                            <li><FaChevronRight /> Request a Demo</li>

                            <li><FaChevronRight /> <a href="/faq">FAQs</a></li>

                        </ul>

                    </div>

                    {/* Quick */}

                    <div className="footer-col">

                        <h3>QUICK LINKS</h3>

                        <ul>

                            <li><FaChevronRight /> Partnerships</li>

                            <li><FaChevronRight /> Privacy Policy</li>

                        </ul>

                        <div className="social-icons">

                            <a href="#"><FaFacebookF /></a>

                            <a href="#"><FaInstagram /></a>

                            <a href="#"><BsTwitterX /></a>

                            <a href="#"><FaLinkedinIn /></a>

                        </div>

                    </div>

                </div>

            </footer>

            <div className="copyright">
                © 2026 Cloud Call. All rights reserved.
            </div>
        </>
    );
}